import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'studio.IkprVS',
    defaultMessage: 'An error has occurred.',
  },
});
